import { createSlice } from "@reduxjs/toolkit";
import {
  getMetrcStrains,
  getMetrcStrainsSync,
  postMetrcStrain,
} from "./metrcStrainsActions";

const initialState = {
  loading: false,
  error: null,
  success: false,
  strains: {},
};

const metrcStrainsSlice = createSlice({
  name: "metrcStrains",
  initialState,
  reducers: {
    resetMetrcStrainError: (state, action) => {
      if (action?.payload) {
        delete state.error[action?.payload];
        if (Object.keys(state.error)?.length === 0) {
          state.error = null;
        }
      } else {
        state.error = null;
      }
      state.loading = false;
      state.success = false;
    },
    resetMetrcStrainSuccess: (state) => {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMetrcStrains.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMetrcStrains.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.strains = payload;
      })
      .addCase(getMetrcStrains.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(getMetrcStrainsSync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMetrcStrainsSync.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getMetrcStrainsSync.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(postMetrcStrain.pending, (state) => {
        state.loading = true;
      })
      .addCase(postMetrcStrain.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.success = true;
        state.strains = {
          meta: state?.strains?.meta,
          results: [payload, ...state?.strains?.results],
        };
      })
      .addCase(postMetrcStrain.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});

export const { resetMetrcStrainError, resetMetrcStrainSuccess } =
  metrcStrainsSlice.actions;
export default metrcStrainsSlice.reducer;
